import LivedigitalSDKError from './LivedigitalSDKError';

class NeedJoinFirstError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Peer must join the channel before performing this request';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? NeedJoinFirstError.DEFAULT_MESSAGE, errorCode ?? 'need_joined_to_channel', meta);
  }
}

export default NeedJoinFirstError;
